import { useEffect } from "react";
import { setRedirectionPage } from "../../features/states/slices";
import { updateBackgroundColour } from "../../functions/UniversalJavascriptFunctions";
import { bootstrapAuthSession } from "../../features/states/thunks";

const unauthenticatedErrorNames = new Set([
    "UserUnAuthenticatedException",
    "NotAuthorizedException",
]);

export function useAuthenticationPage(dispatch, redirection) {
    useEffect(() => {
        updateBackgroundColour();
    }, [dispatch]);

    useEffect(() => {
        if (redirection) {
            dispatch(setRedirectionPage(redirection));
        }
    }, [dispatch, redirection]);
}

export async function completeAuthentication(dispatch, navigate, options = {}) {
    if (options.redirectToSurvey) {
        dispatch(setRedirectionPage("survey"));
    }

    await dispatch(bootstrapAuthSession());
    navigate(options.redirectTo ?? "/");
}

export function isUnauthenticatedUserError(error) {
    return unauthenticatedErrorNames.has(error?.name);
}
